
import { useSocialMediaMeta } from '@/hooks/useSocialMediaMeta';
import { getSocialMediaConfig, SOCIAL_MEDIA_CONFIG } from '@/config/socialMedia';

interface SocialMediaHeadProps {
  page?: keyof typeof SOCIAL_MEDIA_CONFIG.pages;
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  type?: 'website' | 'article' | 'video' | 'book';
}

export const SocialMediaHead = ({
  page,
  title,
  description,
  keywords,
  image,
  type = 'website',
}: SocialMediaHeadProps) => {
  const pageConfig = page ? getSocialMediaConfig(page) : null;
  
  const metaConfig = {
    title: title || pageConfig?.title || SOCIAL_MEDIA_CONFIG.defaultTitle,
    description: description || pageConfig?.description || SOCIAL_MEDIA_CONFIG.defaultDescription,
    keywords: keywords || pageConfig?.keywords,
    image: image || pageConfig?.image || SOCIAL_MEDIA_CONFIG.defaultImage,
    type,
    siteName: SOCIAL_MEDIA_CONFIG.siteName,
  };

  useSocialMediaMeta(metaConfig);

  return null; // This component doesn't render anything
};
